export default __webpack_public_path__ + "static/media/small_jason.1bd43299.png";